import React from 'react';
import { Link } from 'gatsby';
import {
  Hits,
  Index,
} from 'react-instantsearch-dom';
import marked from 'marked';

const formattedIntro = (hit) => {
  if (hit.intro) {
    return marked(hit.intro).replace('<p>', '').replace('</p>', '');
  }

  if (hit.excerpt) {
    return marked(hit.excerpt).replace('<p>', '').replace('</p>', '');
  }

  return null;
}

const HitsInIndex = ({ index, format }) => (
  <Index indexName={ index.name }>
    <Hits className="Hits" hitComponent={ PageHit } />
  </Index>
);

const PageHit = ({ hit }) => {
  return (
    <li>
      <Link to={`/${hit.format}/${hit.slug}`}>
        <div className="contents">
          <p 
            className="title"
            dangerouslySetInnerHTML={{ __html: marked(hit.title).replace('<p>','').replace('</p>','') }}
          />

          <p
            className="description"
            dangerouslySetInnerHTML={{ __html: formattedIntro(hit) }}
          />
        </div>
        <div className="underlay"></div>
      </Link>
    </li>
  );
}

const OverlaySearchResult = ({ indices }) => {
  return (
    <ul>
      {indices.map(index => (
        <HitsInIndex index={index} key={index.name} />
      ))}
    </ul>
  );
}

export default OverlaySearchResult;
